module.exports = __webpack_public_path__ + "static/img/touxiang.a0aa717f.png";